import { Flex, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IModuleItem } from 'src/app/shared/models/store.model'
import { sortByOrder } from 'src/app/shared/utils'
import { getCriticalConfig } from 'src/app/store/masterSetup'
import { CollapseArrowSVG, ExpandArrowSVG } from 'src/assets/icons'
import './index.scss'

interface Props {
  isMenuMinimized: boolean
  openKeys: string[]
  setOpenKeys: (value: React.SetStateAction<string[]>) => void
}

function PanelExpandCollapse(props: Props) {
  const { isMenuMinimized, openKeys, setOpenKeys } = props
  const criticalConfig = useSelector(getCriticalConfig)
  const items: IModuleItem[] = sortByOrder([...(criticalConfig?.moduleItemList || [])], 'orderIndex')
  const itemIds = items?.map((item) => item?.id) || []

  const { t } = useTranslation()

  const handleCollapseExpand = () => {
    if (openKeys?.length === 0) {
      setOpenKeys(itemIds)
      return
    }
    setOpenKeys([])
  }

  return (
    <>
      {!isMenuMinimized && (
        <Flex className='collapse-wrap' gap={10} style={{ width: '100%', height: '60px', justifyContent: 'end' }}>
          {openKeys.length === 0 ? (
            <Flex align='center' gap={4} onClick={handleCollapseExpand}>
              <Typography.Text style={{ fontSize: '14px', userSelect: 'none' }}>
                {t('OverallFunctionality:expand_all_btn')}
              </Typography.Text>
              <ExpandArrowSVG />
            </Flex>
          ) : (
            <Flex align='center' gap={4} onClick={handleCollapseExpand}>
              <Typography.Text style={{ fontSize: '14px', userSelect: 'none' }}>
                {t('OverallFunctionality:collapse_all_btn')}
              </Typography.Text>{' '}
              <CollapseArrowSVG />
            </Flex>
          )}
        </Flex>
      )}
    </>
  )
}

export default PanelExpandCollapse
